import React, { lazy, Suspense, useEffect, useState } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-cream text-plum" data-id="element-0" data-mp="2wk0bn6p7uxy5">
      <MetaPixel data-id="element-1" data-mp="2wj8e3qc26q58" />
      <StickyHeader data-id="element-2" data-mp="2wip7h5ruzo6i" />
      <main data-id="element-3" data-mp="2wi5qbra193tj">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="28u5xmlt5v3cb" />
        <Hero data-id="element-5" data-mp="28surifc8tji1" />
        <SocialProofBar data-id="element-6" data-mp="28sb9kymlev40" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-cream" aria-hidden="true" data-id="element-8" data-mp="23ut97wmn5o7m" />} data-id="element-7" data-mp="23u9q4cl98ts0">
            <DeferredLanding data-id="element-9" data-mp="3ikqy1x7ax04o" />
          </Suspense>}
      </main>
    </div>;
}